import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";


const DynamicFormTemplatesList = Loadable(
  lazy(() =>
    import("./DynamicFormTemplatesList").then(({ DynamicFormTemplatesList }) => ({
      default: DynamicFormTemplatesList,
    }))
  )
);

export const dynamicFormTemplatesRoutes = [
  {
    path: `/settings/dynamic-form-templates`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.CUSTOM_FORM_FIELDS]} allowFullAccess={true}>
        <DynamicFormTemplatesList />
      </AuthorizedRoute>
    ),
  },
]
